// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable, NgZone } from '@angular/core';
import { interval, Subject, Subscription, timer } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

@Injectable()
export class ElementDimensionObserverAggregateService {

  private observers: Map<string, Subscription> = new Map();
  private events$ = new Subject<void>();

  readonly allEvents$ = this.events$.asObservable();

  constructor(
    private zone: NgZone,
  ) {
  }

  observe(key: string, element: HTMLElement): void {
    if (this.observers.has(key)) {
      this.unobserve(key);
    }

    const props = ['height', 'width'];
    this.zone.runOutsideAngular(() => {
      const subscription = interval(150).pipe(
        takeUntil(timer(600)),
        map(() => element.getBoundingClientRect()),
        distinctUntilChanged((a, b) => {
          return !props.some(prop => a[prop] !== b[prop]);
        }),
      ).subscribe(() => this.events$.next());
      this.observers.set(key, subscription);
    });
  }

  unobserve(key: string): void {
    if (!this.observers.has(key)) {
      return;
    }

    const observer = this.observers.get(key);
    observer.unsubscribe();
    this.observers.delete(key);
  }

  removeAllObservers(): void {
    this.observers.forEach(subscription => subscription.unsubscribe());
  }
}
